import { Component, OnInit, ViewChild,ElementRef, Input } from '@angular/core';
import * as ApexCharts from 'apexcharts';

@Component({
    selector: 'app-anasayfa-grafik',
    templateUrl: './anasayfa-grafik.component.html',
    styleUrls: ['./anasayfa-grafik.component.css']
})

export class AnasayfaGrafikComponent implements OnInit {

    @Input("datas") datas:any

    @ViewChild('chartelement') chartelement: ElementRef;

    options:object = null
    chart:any = null
    
    constructor() { }

    ngAfterViewInit() {
        this.chart = new ApexCharts(this.chartelement.nativeElement,this.options)
        this.chart.render()
    }

    ngOnInit() {
        this.options = {
            chart: {
                type: 'bar',
                toolbar: {
                    tools: {
                      download: false,
                    }
                },
            },
            series: [
                {
                    name: 'Bu Ay İçinde Açılan Talep Sayıları',
                    data: this.datas[0].values,
                    color: '#007bff'
                }, 
                {
                    name: 'Bu Ay İçinde Sonlandırılan Talep Sayıları',
                    data: this.datas[1].values,
                    color: '#28a745'
                }, 
                // {
                //     name: 'Bu Ay İçinde Sonlandırıalan TL Talep Tutarları',
                //     data: this.datas[2].values,
                //     color: '#ffc107'
                // }
            ],
            stroke: {
                show: true,
                width: 2,
                colors: ['transparent']
            },
            xaxis: {
                categories: [
                    "Acil",
                    "Yerel",
                    "Satın Alma"
                ]
            }
        }
    }
}   